const rawApiUrl = process.env.REACT_APP_API_URL || ""
const siteDomain = process.env.REACT_APP_SITE_DOMAIN || ""

export const server = rawApiUrl.startsWith("http")
  ? rawApiUrl
  : `${siteDomain}${rawApiUrl}`

export const speechServiceURL = `${process.env.REACT_APP_SITE_DOMAIN}/actividades/audio_receiver.ashx`

export const newSpeechServiceURL =
  process.env.REACT_APP_ENVIORNMENT === "beta"
    ? `https://beta.smasheducation.com/SpeechRecognition/transcription`
    : `https://login.smasheducation.com/SpeechRecognition/transcription`

export const smashGamesURL = `${process.env.REACT_APP_SITE_DOMAIN}/Professor/smash/V2/Game`

export const legacySSOUrl = process.env.REACT_APP_LEGACY_PROFESOR_SSO_URL
export const professorLoginVersion =
  process.env.REACT_APP_PROFESSOR_LOGIN_VERSION

export const translatorServiceURL =
  process.env.REACT_APP_ENVIORNMENT === "development"
    ? `http://localhost:5000/services/translations`
    : process.env.REACT_APP_ENVIORNMENT === "beta"
    ? `https://beta.smasheducation.com/services/translations`
    : `https://www.smasheducation.com/services/translations`

export const textAudioAlignmentServiceURL =
  process.env.REACT_APP_ENVIORNMENT === "development"
    ? `https://www.smasheducation.com/services/audioTextMapper`
    : process.env.REACT_APP_ENVIORNMENT === "sandbox"
    ? `https://sandbox.smasheducation.com/services/audioTextMapper`
    : `https://www.smasheducation.com/services/audioTextMapper`

export const LANGUAGES_ASSETS =
  "https://smasheducation.com/services/dictionaryAssets"

export const MODULE_TYPES_IMAGES_SOURCE = `${process.env.REACT_APP_MS_REDIRECT_URI}/source/ui/content/module/types/images`
